import {
  LIST_SPECIALIST_REQUEST,
  LIST_SPECIALIST_SUCCESS,
  LIST_SPECIALIST_FAIL,
  LIST_SPECIALIST_SUMMARY_REQUEST,
  LIST_SPECIALIST_SUMMARY_SUCCESS,
  LIST_SPECIALIST_SUMMARY_FAIL,
  CREATE_SPECIALIST_REQUEST,
  CREATE_SPECIALIST_SUCCESS,
  CREATE_SPECIALIST_FAIL,
  DETAIL_SPECIALIST_REQUEST,
  DETAIL_SPECIALIST_SUCCESS,
  DETAIL_SPECIALIST_FAIL,
  UPDATE_SPECIALIST_REQUEST,
  UPDATE_SPECIALIST_SUCCESS,
  UPDATE_SPECIALIST_FAIL,
  DELETE_SPECIALIST_REQUEST,
  DELETE_SPECIALIST_SUCCESS,
  DELETE_SPECIALIST_FAIL,
  RESET_SPECIALIST
} from '../../constants/specialists'

const initialState = {
  loading: false,
  specialists: [],
  specialist: {},
  specialistsSummary: [],
  pageable: {},
  error: null
}

const specialistsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SPECIALIST_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SPECIALIST_SUCCESS:
      return {
        ...state,
        loading: false,
        specialists: action.payload,
        pageable: action.pageable
      }
    case LIST_SPECIALIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        specialists: []
      }
    case LIST_SPECIALIST_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SPECIALIST_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        specialistsSummary: action.payload
      }
    case LIST_SPECIALIST_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_SPECIALIST_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_SPECIALIST_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_SPECIALIST_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_SPECIALIST_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_SPECIALIST_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        specialist: action.payload
      }
    case DETAIL_SPECIALIST_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_SPECIALIST_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_SPECIALIST_SUCCESS:
      return {
        ...state,
        loadingUpdate: false
      }
    case UPDATE_SPECIALIST_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_SPECIALIST_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_SPECIALIST_SUCCESS:
      const specialistId = action?.payload

      const findeIndexDelete = state?.specialists?.findIndex((item) => item?.id === specialistId)
      const newStateSpecialistsDelete = [...state?.specialists]
      newStateSpecialistsDelete?.splice(findeIndexDelete, 1)

      return {
        ...state,
        loadingDelete: false,
        specialists: newStateSpecialistsDelete
      }
    case DELETE_SPECIALIST_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    case RESET_SPECIALIST:
      return {
        ...state,
        loading: false,
        specialists: [],
        pageable: {},
        error: null
      }
    default:
      return state
  }
}

export default specialistsReducer